// Define the FilterType enum
export enum FilterType {
  MONTANT_INFER = 'MONTANT_INFER',
  MONTANT_SUPER = 'MONTANT_SUPER',
  CREEES_A = 'CREEES_A',
  CREEE_JU = 'CREEE_JU',
  JOURNAL = 'JOURNAL',
  JOURNAL_TYPE = 'JOURNAL_TYPE',
  LETTRES_A_PARTIR = 'LETTRES_A_PARTIR',
  LETTRES_JU = 'LETTRES_JU',
  NON_LETTRES = 'NON_LETTRES',
  COMPTE_COMPTABLE = 'COMPTE_COMPTABLE',
  COMPTE_COMMANCANT = 'COMPTE_COMMANCANT',
  LIBELLE_COMMANCANT = 'LIBELLE_COMMANCANT',
  LIBELLE_CONTIENT = 'LIBELLE_CONTIENT',
  NUMERO_DE_PIECE = 'NUMERO_DE_PIECE',
  PIECE_ASSOCIEE = 'PIECE_ASSOCIEE',
  SANS_PIECE_ASSOCIEE = 'SANS_PIECE_ASSOCIEE',
  TOUTES_LIGNES = 'TOUTES_LIGNES',
  LIGNES_LETTRES = 'LIGNES_LETTRES',
  LIGNES_NON_LETTRES_PLUS_LETTRAGE_PARTIEL = 'LIGNES_NON_LETTRES_PLUS_LETTRAGE_PARTIEL',
  LETTRAGE_PARTIEL = 'LETTRAGE_PARTIEL',
  LIGNES_VUES = 'LIGNES_VUES',
  LIGNES_NON_VUES = 'LIGNES_NON_VUES',
  LIGNES_LETTRES_NON_VALIDEES = 'LIGNES_LETTRES_NON_VALIDEES',
  LIGNES_VALIDEES = 'LIGNES_VALIDEES',
  LIGNES_NON_VALIDEES = 'LIGNES_NON_VALIDEES',
  LIGNES_TAGUEES = 'LIGNES_TAGUEES',
  LIGNES_NON_TAGUEES = 'LIGNES_NON_TAGUEES',
  COMPTABILITE_STANDARD_JOURNAL = 'COMPTABILITE_STANDARD_JOURNAL',
  COMPTABILITE_ANALYTIQUE_JOURNAL = 'COMPTABILITE_ANALYTIQUE_JOURNAL',
  COMPTABILITE_STANDARD_GRAND_LIVRE = 'COMPTABILITE_STANDARD_GRAND_LIVRE',
  COMPTABILITE_ANALYTIQUE_GRAND_LIVRE = 'COMPTABILITE_ANALYTIQUE_GRAND_LIVRE',
  COMPTE_CATEGORY = 'COMPTE_CATEGORY',
  COMPTE_COURANT_COMPTABLE = 'COMPTE_COURANT_COMPTABLE',
  COMPTE_COURANT_COMMANCANT = 'COMPTE_COURANT_COMMANCANT',
  COMPTE_NON_MOVEMENTE = 'COMPTE_NON_MOVEMENTE',
  COMPTE_MOVEMENTE = 'COMPTE_MOVEMENTE',
}

export const filtersWithDate = [
  'CREEES_A',
  'CREEE_JU',
  'LETTRES_A_PARTIR',
  'LETTRES_JU',
  'NON_LETTRES',
];
